import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Card, Button } from 'react-bootstrap';
import AppNavbar from '@/components/layout/AppNavbar';
import Footer from '@/components/layout/Footer';
import LoginForm from '@/features/auth/components/LoginForm';
import Nickname from '../components/IdolNickname';
import LoginIdols from '../components/LoginIdols';
import HeroSection from '../components/HeroSection';
import LandingSections from '../components/LandingSections';
import { setIdolId, setIdolUuid } from '@/shared/store/slices/userSlice';

export default function LandingPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [showNickname, setShowNickname] = useState(false);
  const [showIdol, setShowIdol] = useState(false);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const handleResponse = (res) => {
    dispatch(setIdolId(res.data.idol_id));
    dispatch(setIdolUuid(res.data.idol_uuid));
    navigate(`/idol-update/${res.data.idol_uuid}`);
  };

  return (
    <div>
      <AppNavbar />
      <div className="nav-padding-guest mb-5">
        <HeroSection>
          <Card className="shadow login-card mx-auto border-0 opacity-80 text-wrap">
            {showNickname ? (
              <Nickname onResponse={handleResponse} />
            ) : showIdol ? (
              <LoginIdols onCreateIdol={() => setShowNickname(true)} />
            ) : (
              <>
                <Card.Title className="loginbox-title text-center border-bottom">
                  <h2 className="p-3">{t("login")}</h2>
                </Card.Title>
                <Card.Body className="py-2 px-4">
                  <LoginForm
                    onShowIdol={setShowIdol}
                    onShowNickname={setShowNickname}
                  />
                </Card.Body>
                <Card.Footer className="py-3 px-4">
                  <div className="d-flex gap-3 mx-auto">
                    <div className="w-100">
                      <Link to="/sign-up" className="w-100">
                        <Button className="btn btn-outline-primaryF w-100">
                          {t("signup")}
                        </Button>
                      </Link>
                    </div>
                    <div className="w-100">
                      <Link to="/forget-password" className="w-100">
                        <Button className="btn btn-neutral w-100">
                          {t("forget_password")}
                        </Button>
                      </Link>
                    </div>
                  </div>
                </Card.Footer>
              </>
            )}
          </Card>
        </HeroSection>

        <LandingSections onScrollToTop={scrollToTop} />
      </div>
      <Footer />
    </div>
  );
}
